export {
  PersonalInformation,
  AccountMenuNavigation,
  BOTAccountPersonalInformation
} from '../MyAccount'
